module.exports = __webpack_public_path__ + "static/media/discord_logo.b18c39e0.png";